<template>
  <div class="vs-component vs-con-input-label vs-input">
    <label
      v-if="label"
      class="vs-input--label"
    >{{ label }}</label>
    <div class="vs-con-input vs-input--wrapper">
      <v-autonumeric
        ref="autonumeric"
        class="vs-input--input"
        :class="{ 'rounded-r-none': !isEmpty($slots) }"
        :value="$attrs.value"
        :options="$attrs.options"
        :disabled="$attrs.disabled"
        v-on="$listeners"
      />
      <div class="slot">
        <slot />
      </div>
      <span
        v-if="placeholder && $attrs.value === null"
        class="input-span-placeholder vs-input--placeholder"
      >
        {{ placeholder }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Autonumeric',
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  mounted() {
    const input = this.$refs.autonumeric.$el
    input.addEventListener('focusin', (event) => {
      event.target.parentElement.classList.add('active')
    })
    input.addEventListener('focusout', (event) => {
      event.target.parentElement.classList.remove('active')
    })
  }
}
</script>

<style lang="scss" scoped>
.vs-input {
  @apply w-form-field;
  @apply relative;
  @apply inline-block;

  &--label {
    @apply inline-block;
    @apply text-sm;
    @apply font-semibold;
    @apply text-grey;
    @apply p-0;
    @apply mb-1;
  }

  &--wrapper {
    @apply relative;
    @apply rounded-lg;
    @apply flex;
    @apply flex-row;
    background-color: #F1F1FD;

    &.active {
      @apply rounded-lg;
      outline: 2px solid #6546C3;
    }
  }

  &--input {
    @apply bg-transparent;
    @apply border-none;
    @apply outline-none;
    @apply shadow-none;
    @apply py-85;
    @apply px-4;
    @apply text-base;
    @apply font-normal;

    &::-webkit-input-placeholder { /* Edge */
      @apply p-0;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      @apply p-0;
    }

    &::placeholder {
      @apply p-0;
    }

    &:disabled {
      background-color: #ECEBED;
    }

    &:disabled,
    &:disabled+.vs-input--placeholder {
      @apply text-grey-001;
      @apply cursor-default;
      @apply pointer-events-none;
    }
  }

  &--placeholder {
    @apply p-4 #{!important};
    @apply text-base;
    @apply font-normal;
    @apply h-full;
    @apply text-gray-500;
  }

  .slot {
    height: calc( 1rem * 10 / 3);
  }

  .rounded-r-none {
    @apply rounded-r-none #{!important};
  }
}
</style>
